import {
  ApiGetMyWishlistsFailedAction,
  ApiGetMyWishlistsSucceededAction,
  apiGetMyWishlistsFailedType,
  apiGetMyWishlistsRequested,
  apiGetMyWishlistsSucceededType
} from '@spa/lib/store/api/wishlists/getMyWishlistsApi';
import {
  GetMyWishlistsRequestedAction,
  getMyWishlistsFailed,
  getMyWishlistsSucceeded
} from '@spa/lib/store/wishlists/wishlistsSlice';
import generateActionId from '@spa/lib/generateActionId';
import { put } from 'typed-redux-saga';
import waitForSucceededOrFailedAction from '@spa/lib/store/sagas/session/waitForSucceededOrFailedAction';

function* getMyWishlistsSaga({
  payload: { actionId: requestedActionId }
}: GetMyWishlistsRequestedAction): Generator {
  const actionId: number = generateActionId();

  yield* put(apiGetMyWishlistsRequested({ actionId, parentActionId: requestedActionId }));

  const waitResult = yield* waitForSucceededOrFailedAction<
    typeof apiGetMyWishlistsSucceededType,
    typeof apiGetMyWishlistsFailedType,
    ApiGetMyWishlistsSucceededAction,
    ApiGetMyWishlistsFailedAction
  >(actionId, apiGetMyWishlistsSucceededType, apiGetMyWishlistsFailedType);

  if (waitResult.type === 'succeeded') {
    yield* put(
      getMyWishlistsSucceeded({ requestedActionId, wishlists: waitResult.action.payload.result })
    );
  } else {
    yield* put(
      getMyWishlistsFailed({
        error: waitResult.action.payload.error,
        requestedActionId
        // wishlists: []
      })
    );
  }
}

export default getMyWishlistsSaga;
